var Queensland = "Queensland";
var Tasmania = "Tasmania";
var Victoria = "Victoria";
var AUStates = {
	"Australian Capital Territory": "Territorio de la Capital Australiana",
	"New South Wales": "Nueva Gales del Sur",
	"Northern Territory": "Territorio del Norte",
	Queensland: Queensland,
	"South Australia": "Australia del Sur",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "Australia occidental"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
